export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
